export default __webpack_public_path__ + "static/media/report_icon_white.564439a6.svg";